// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueTouch from 'vue-touch'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import store from './store'
import UserApi from '@/api/UserApi'
import TwApi from '@/api/TwApi'
import StockApi from '@/api/StockApi'
import DynamicLinkApi from '@/api/DynamicLinkApi'

Vue.config.productionTip = false

Vue.use(VueTouch, {name: 'v-touch'})
if (process.env.NODE_ENV === 'production') {
  // activate GA only under the release env
  Vue.use(VueAnalytics, {
    id: 'UA-121209972-1',
    router
  })
}
// test
window.apis = {
  UserApi,
  TwApi,
  StockApi,
  DynamicLinkApi
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js